export default __webpack_public_path__ + "static/media/services_transport.7a7deaea.jpg";